module.exports = __webpack_public_path__ + "img/10.d6df2b2d.jpg";